import React, { useState } from "react";
import { Modal, Button } from "antd";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import Lottie from "lottie-react";
import validateAnimation from "../../../../assets/animations/validate.json";
import warningAnimation from "../../../../assets/animations/close.json";
import "../utils/validate.css";
import {updateKycStatus } from "../services/merchentApi";

const KycMerchent = ({ modal, setModal, toggle, selectedMerchent, mode = "validate" }) => {
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const isValidateMode = mode === "validate";
const isKycActive = selectedMerchent?.kycVerified;

const handleAction = async () => {
  if (!selectedMerchent?.id) {
    toast.error("Marchand invalide");
    return;
  }

  setIsLoadingSubmit(true);
  try {
    await updateKycStatus(selectedMerchent.id, !selectedMerchent.kycVerified);

    toast.success(
      selectedMerchent.kycVerified
        ? "KYC désactivé avec succès"
        : "KYC activé avec succès"
    );

    queryClient.invalidateQueries("merchents");
    setModal(false);
  } catch (error) {
    toast.error(`Erreur : ${error?.message || error}`);
  } finally {
    setIsLoadingSubmit(false);
  }
};

  return (
    <Modal
      open={modal}
      onCancel={toggle}
      footer={null}
      centered
      width={600}
      className="modal-validate"
    >
      <div className="validate-modal-content">
        <h2 className="validate-title">
      {isKycActive
        ? `Désactivation du KYC du marchand « ${selectedMerchent?.firstName} ${selectedMerchent?.lastName} »`
        : `Activation du KYC du marchand « ${selectedMerchent?.firstName} ${selectedMerchent?.lastName} »`}
    </h2>


        <div className="validate-animation">
          <Lottie
            animationData={isValidateMode ? validateAnimation : warningAnimation}
            style={{ height: 180 }}
            loop
          />
        </div>

        <div className="validate-description">
          {isValidateMode ? (
            <>
              <p>Êtes-vous sûr de vouloir activer le kyc de ce marchant ?</p>
              <p>Cette action le rendra kyc actif dans l’environnement de production.</p>
              <p><strong>{selectedMerchent?.firstName + " " + selectedMerchent?.lasttName}</strong> pourra désormais reprendre ses activités.</p>
            </>
          ) : (
            <>
              <p>Voulez-vous vraiment désactiver le kyc de ce marchant ?</p>
              <p>Il ne pourra plus continuer ses activés ni se connecter à l'application.</p>
              <p><strong>{selectedMerchent?.firstName + " " + selectedMerchent?.larstName}</strong> sera marqué comme kyc inactif.</p>
            </>
          )}
        </div>

        <div className="validate-footer">
          <Button onClick={() => setModal(false)} disabled={isLoadingSubmit}>
            Annuler
          </Button>
          <Button
            danger={isKycActive}
            type={isKycActive ? "default" : "primary"}
            onClick={handleAction}
            loading={isLoadingSubmit}
          >
            {isKycActive ? "Désactiver" : "Activer"}
          </Button>

        </div>
      </div>
    </Modal>
  );
};

export default KycMerchent;
